import { render } from "./SearchSvg.vue?vue&type=template&id=34e48e63"
import script from "./SearchSvg.vue?vue&type=script&lang=js"
export * from "./SearchSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__